import ProjectAgentProactivityControl from '@/frontend/features/Fde/ProjectAgentProactivityControl'
import type { ProjectAgent } from '@/frontend/features/Fde/types'

export interface ProactivityCopy {
  meeting_preparation: string; meeting_preparation_description: string; meeting_hours: string
  meeting_day_starts: string; meeting_day_ends: string; meeting_schedule: string; meeting_save: string
  meeting_delivery: string; meeting_delivery_conversation: string; meeting_delivery_native: string
  meeting_delivery_conversation_description: string; meeting_delivery_native_description: string
  title: string; description: string; enabled: string; approval: string
  source_preparation: string
  source_preparation_description: string; approval_description: string
  customize: string; customized: string; instructions_title: string; instructions_description: string
  instructions_label: string; instructions_placeholder: string; instructions_fixed: string
  instructions_empty: string; instructions_clear: string; save: string; saving: string; cancel: string; close: string
  attention_title: string; attention_description: string; attention_label: string; attention_reset: string; attention_fixed: string
  details: string; approval_hint: string; pause_hint: string; rollout_hint: string; retained_hint: string
}

export default function ProjectAgentProactivity({ projectId, assignments, copy, disabled }: {
  projectId: string; assignments: ProjectAgent[]; copy: ProactivityCopy; disabled: boolean
}) {
  if (!assignments.length) return null
  return <section className="mt-10 border-t border-border pt-6" aria-label={copy.title}>
    <h2 className="text-base font-semibold">{copy.title}</h2>
    <p className="mt-1 text-xs text-muted-foreground">{copy.description}</p>
    <div className="mt-4 divide-y divide-border">
      {assignments.map((assignment) => assignment.proactivity && <ProjectAgentProactivityControl
        key={`${projectId}:${assignment.id}`}
        projectId={projectId} assignment={assignment} copy={copy} disabled={disabled} />)}
    </div>
    <details className="mt-3 text-xs leading-relaxed text-muted-foreground">
      <summary className="w-fit cursor-pointer">{copy.details}</summary>
      <div className="mt-3 space-y-2"><p>{copy.approval_hint}</p><p>{copy.pause_hint}</p><p>{copy.retained_hint}</p><p>{copy.rollout_hint}</p></div>
    </details>
  </section>
}
